module.exports = "/assets/images/0da34603b09651c02566c5273785465b.svg";